import NextHead from "next/head";
import { LearningOpportunity } from "@/server/backend-api";
import config from "../config";

type Props = {
  title?: string | null;
  description?: string | null;

  ogType?: "website";
  ogUrl?: string;
  ogImageUrl?: string;
};

export const Head = (props: Props) => {
  return (
    <NextHead>
      <title>{props.title ? `${props.title} - ECIU` : "ECIU"}</title>
      <link rel="icon" href="/favicon.png" />
      {props.title && <meta property="og:title" content={props.title} />}
      {props.description && (
        <meta
          name="description"
          property="og:description"
          content={props.description}
        />
      )}
      {props.ogType && <meta property="og:type" content={props.ogType} />}
      {props.ogUrl && <meta property="og:url" content={props.ogUrl} />}
      {props.ogImageUrl && (
        <meta property="og:image" content={props.ogImageUrl} />
      )}
    </NextHead>
  );
};

interface LearningOppHeadProps {
  learningOpp: LearningOpportunity;
}

export function LearningOppHead(props: LearningOppHeadProps) {
  const { learningOpp } = props;
  const DESCRIPTION_MAX_CHARS = 400;
  const fullUrl = `${config.baseUrl}${learningOpp.url}`;
  const fullImageUrl =
    learningOpp.imageUri === null
      ? undefined
      : `${config.cdn.url}/${learningOpp.imageUri}`;
  const description = learningOpp.introduction?.slice(0, DESCRIPTION_MAX_CHARS);
  return (
    <Head
      title={learningOpp.title}
      description={description}
      ogType="website"
      ogUrl={fullUrl}
      ogImageUrl={fullImageUrl}
    />
  );
}
